import React, {Component} from 'react';
import {SnackbarMessage} from '@proxibid/proxiponents';
import * as PropTypes from "prop-types";

class SnackbarMessageManager extends Component {

    static propTypes = {
        children: PropTypes.string.isRequired
    };

    render() {
        return (
            <SnackbarMessage
                {...this.props}
            >{this.props.children}</SnackbarMessage>
        );
    }
}

export default SnackbarMessageManager;
